import { useState, useEffect } from 'react';
// portal node might not be available immediately, so we need to use a hook to get it
export var usePortalNode = function (id) {
    var _a = useState(document.getElementById(id)), node = _a[0], setNode = _a[1];
    useEffect(function () {
        if (!node) {
            var nodeEl = document.getElementById(id);
            setNode(nodeEl);
        }
    }, [id, node]);
    return node;
};
